import type { FC } from "react";

import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import { Legends } from "app/components/React/Legends/Legends";
import type { ILegendItem, ILegendItems } from "app/components/React/Legends/legendsTypes";

const TopLegendsWrapper = styled(Flex)`
    flex-wrap: wrap;
    .legends-container {
        gap: 32px;
        row-gap: 16px;
    }
`;

interface IChannelsOverviewBarChartTopLegends {
    legendItems: ILegendItems;
    onLegendsChange: (legendItem: ILegendItem) => void;
}

export const ChannelsOverviewBarChartTopLegends: FC<IChannelsOverviewBarChartTopLegends> = ({
    legendItems,
    onLegendsChange,
}) => {
    return (
        <TopLegendsWrapper
            alignItems="flex-start"
            data-automation="channelsOverviewBarChartTopLegends"
        >
            <Legends
                legendItems={legendItems}
                toggleSeries={onLegendsChange}
                gridDirection="row"
                textMaxWidth={"160px"}
                legendsGap={"32px"}
            />
        </TopLegendsWrapper>
    );
};
